// src/services/axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
    timeout: 15000,
});

// Aggiunge il token a tutte le richieste se presente
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));

// Gestisce errori di risposta: tenta refresh su 401, redirect login se fallisce
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const original = error.config;

        if (error.response?.status === 401 && !original._retry) {
            original._retry = true;
            try {
                const { data } = await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/refresh-token`,
                    {},
                    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
                );
                localStorage.setItem('token', data.token);
                original.headers.Authorization = `Bearer ${data.token}`;
                return axiosInstance(original);
            } catch {
                localStorage.removeItem('token');
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            }
        }

        if (error.response?.status === 403) {
            // PSC-144: un 403 "permesso mancante" significa che il ruolo non può usare quella
            // funzione, non che la sessione sia scaduta: niente logout, la pagina gestisce l'errore.
            if (error.response?.data?.code === 'PERMESSO_MANCANTE') {
                return Promise.reject(error);
            }
            localStorage.removeItem('token');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
